

const state = {       
    blocks:[
        
    ]
 
};

export default {
  namespaced: false,
  state,
  
};